module.exports = __webpack_public_path__ + "img/logo-creative-tim.dc0324d3.svg";